import { CostCentersConfigurationsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useCostCenterConfiguration = ({ skip }: { skip?: boolean }) => {
  const { data, loading, refetch } = useQuery(CostCentersConfigurationsDocument, {
    skip,
  })

  const configurations = data?.costCenters.configurationsConnection.nodes || []

  return {
    isLoading: loading,
    configurations,
    refetch,
  }
}
